module.exports = __webpack_public_path__ + "img/gallery01.e16f0e8f.jpg";